import { createHttpEndpoint } from '../../utils'

import type {
  GetHomepageMessages,
  GetHomepageSalesMetrics,
  GetHomepageUserReviews,
} from './merchant-homepage.d'

/**
 * Retrieves Merchant message for the homepage banner
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Merchant-homepage/operation/get-bm-merchants-homepage-messages}
 */
export const getHomepageMessages =
  createHttpEndpoint<GetHomepageMessages.Response>({
    method: 'GET',
    operationId: 'getHomeMessages',
    path: '/bm/merchants/homepage/messages',
  })

/**
 * Get the user reviews indicators for the merchant homepage.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Merchant-homepage/operation/get-bm-merchants-homepage-user-reviews}
 */
export const getHomepageUserReviews =
  createHttpEndpoint<GetHomepageUserReviews.Response>({
    method: 'GET',
    operationId: 'getHomeUserReviews',
    path: '/bm/merchants/homepage/user-reviews',
  })

/**
 * Get the sales metrics from the last 7 days for the merchant homepage.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Merchant-homepage/operation/get-bm-merchants-homepage-sales-metrics}
 */
export const getHomepageSalesMetrics =
  createHttpEndpoint<GetHomepageSalesMetrics.Response>({
    method: 'GET',
    operationId: 'getHomeSalesMetrics',
    path: '/bm/merchants/homepage/sales-metrics',
  })
